import { COLOR_GREEN_700 } from '@alltrails/denali/tokens';
import { createParkPinSvg } from './svgMarkerComponents';

const defaultParkPinSvg = createParkPinSvg('default-park-pin', COLOR_GREEN_700);

export default defaultParkPinSvg;
